import { F0Button } from '@factorialco/f0-react'
import { Delete } from '@factorialco/f0-react/icons/app'
import { Tooltip } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface Props {
  disabled?: boolean
  onDeleteAction: () => void
  variant?: 'critical' | 'outline' | 'neutral'
}

const DeleteButton = ({ disabled, onDeleteAction, variant = 'outline' }: Props) => {
  return (
    <Tooltip label={i18n.t('shift_management.actions.delete')}>
      <F0Button
        hideLabel
        icon={Delete}
        onClick={onDeleteAction}
        size="md"
        variant={variant}
        disabled={disabled}
      />
    </Tooltip>
  )
}

export default DeleteButton
